<template>
  <span
    class="inline-block rounded border border-solid px-2 py-0.5 text-xs font-bold"
    :class="badgesClass"
  >
    {{ name }}
  </span>
</template>

<script setup lang="ts">
  interface IProps {
    theme: 'red' | 'blue' | 'orange' | 'light-blue';
    name: string;
  }

  const props = withDefaults(defineProps<IProps>(), {
    theme: 'red',
    name: '',
  });

  const badgesClass = computed((): string => {
    switch (props.theme) {
      case 'blue':
        return 'text-blue-400 bg-blue-100 border-blue-200';
      case 'light-blue':
        return 'text-[#668DB2] bg-white border-[#BECFDF]';
      case 'orange':
        return 'text-orange-400 bg-orange-100 border-orange-200';
      default:
        return 'text-red-400 bg-red-100 border-red-200';
    }
  });
</script>
